import React from 'react'
import { Plus } from 'lucide-react'

interface AddRowButtonProps {
  onClick: () => void
  className?: string
}

export const AddRowButton: React.FC<AddRowButtonProps> = ({ onClick, className = '' }) => {
  return (
    <button
      onClick={onClick}
      className={`btn btn-success ${className}`}
    >
      <Plus className="icon" />
      <span>行を追加</span>
    </button>
  )
} 